/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { usesGetterSetter } from 'trait/uses'
import toExplicitBoolean from 'model/_shared/transformer/toExplicitBoolean'

const descriptor = 'model::ticket::warranty'

export default pipe(
  modelComposition(descriptor),
  usesGetterSetter(G.TRANSFORMER, {
    isCovered: toExplicitBoolean('isCovered'),
  }),
)
